import { Payment } from 'src/contexto/hooks/usePaymentMethod'

export const arePixAndBilletAvailable = (payment: Payment): boolean =>
  Boolean(payment.pix && payment.billet)

export const arePixOrBilletAvailable = (payment: Payment): boolean =>
  Boolean(payment.pix || payment.billet)

export const isOnlyBilletInCashAvailable = (payment: Payment): boolean =>
  Boolean(!payment.pix && payment.billet)

export const isOnlyPixInCashAvailable = (payment: Payment): boolean =>
  Boolean(payment.pix && !payment.billet)

export const isCreditCardAvailable = (payment: Payment): boolean =>
  Boolean(payment.creditCard)

export const getInCashAvailablePaymentMethods = (payment: Payment): string => {
  if (arePixAndBilletAvailable(payment)) return 'Pix ou Boleto'
  if (!arePixOrBilletAvailable(payment)) return ''
  return isOnlyPixInCashAvailable(payment) ? 'Pix' : 'Boleto'
}

export const hoursToCountAsNotCurrentCancelling = (): number => 72

type DisplayedPriceInput = {
  isAvailable: boolean
  // À vista (Pix/Boleto): o `price` do card, mapeado de formas_pagamento.boleto.por
  price: number
  // Cartão: o `por` do card
  por: number
}

// Preço que o card mostra em destaque (GProductVertical, @gazin/ecommerce-ui): indisponível
// não mostra preço; com Pix ou Boleto ativos, o à vista; só com cartão, o "por". O JSON-LD
// do hotsite usa esta regra sobre os mesmos campos do card (critério 17). TNDC-438.
export const resolveDisplayedPrice = (
  { isAvailable, price, por }: DisplayedPriceInput,
  payment: Payment
): number | null => {
  if (!isAvailable) return null

  const value = arePixOrBilletAvailable(payment)
    ? price
    : isCreditCardAvailable(payment)
    ? por
    : null

  return typeof value === 'number' && value > 0 ? value : null
}
